export default "__VITE_ASSET__CCCgf79u__"